import constants from "../constants/constants";
import Awards from "./awards.component";
import ScrollDownIndicator from "./scrollDownloadIndicator";
import { useUserParams } from "../hooks/useUserParams";

export default function Hero() {
    const {
        getCurrentAgentName,
        getCurrentAgentTitle,
        getCurrentBrokerage,
        getCurrentHeadshot,
        getCurrentLogo,
    } = useUserParams();

    return (
        <section className="w-full min-h-[90vh] flex items-center justify-center  relative overflow-hidden">
            <div className="relative flex flex-col md:flex-row items-center justify-center w-full max-w-[1600px] mx-auto">
                {/* Image with large rounded corners */}
                <div className="w-full md:w-[98%] aspect-[19/9] bg-gray-200 rounded-[48px] flex items-center justify-center overflow-hidden">
                    <img
                        src={constants.HOME_IMAGE}
                        alt="Hero"
                        fill
                        className="object-cover w-full h-full rounded-[48px]"
                        priority
                    />
                </div>
                {/* Overlayed text */}
                <div className="absolute left-0 md:left-12 top-1/2 -translate-y-1/2 z-10 p-12 bg-white/80 rounded-[48px] shadow-lg max-w-[600px] flex flex-col gap-6">
                    <div className="flex flex-col items-center gap-6 mb-4">
                        <img
                            src={getCurrentHeadshot()}
                            alt="Agent Headshot"
                            width={200}
                            height={200}
                            className="rounded-full aspect-square object-cover border-4 border-ocean"
                            priority
                        />
                        <div className="flex flex-col">
                            <h1 className="text-ocean text-4xl sm:text-5xl font-serif font-bold leading-tight">
                                {getCurrentAgentName()}
                            </h1>
                            <h3 className="text-ocean text-3xl font-sans font-bold mt-2 whitespace-normal">
                                {getCurrentAgentTitle()}
                            </h3>
                            <div className="flex items-center gap-2">
                                <img
                                    src={getCurrentLogo()}
                                    alt="Brokerage Logo"
                                    width={80}
                                    height={40}
                                />
                                <h4 className="text-ocean text-2xl font-sans font-bold whitespace-normal">
                                    {getCurrentBrokerage()}
                                </h4>
                            </div>
                        </div>
                        <div>
                            <Awards />
                        </div>
                    </div>
                </div>
            </div>
            <div className="absolute left-1/2 -translate-x-1/2 bottom-8 z-20">
                <ScrollDownIndicator />
            </div>
        </section>
    );
}
